import React, { useState } from "react";
import { isMobile, isTablet } from "react-device-detect";
import { PlatformMobile } from "../../helpers/Constants";
const NSCardButton = ({ options, callBack }) => {
  const { title, icon, iconOptional, horizontal } = options;

  const handlerOnClick = () => {
    if (callBack) {
      callBack();
    }
  };
  return (
    <>
      <div
        onClick={handlerOnClick}
        style={{
          background: "#fff",
          width: "100%",
        }}
        className={`px-1 ${PlatformMobile? 'py-3': 'py-5'} h-full cursor-pointer bg-white  rounded-[10px] flex flex-col items-center shadow shadow-[#2AAC9C4D]`}
      >
        <div
          className={`text-center flex p-1 items-center gap-0  h-full w-full ${
            horizontal
              ? "justify-between px-6"
              : "justify-between flex-col items-between"
          }`}
        >
          <div
            className={` flex flex-1 flex-col p-1 justify-center items-between font-[500]`}
          >
            {title}
          </div>
          <div className={`flex gap-2 ${horizontal ? "mt-0" : "mt-5"}`}>
            <div className="flex items-center justify-center w-2/6 rounded bg-[#FEEFF2] rounded-[8px] p-[4px] w-[48px] h-[48px]">
              <img src={icon} alt={icon} />
            </div>
            {iconOptional && (
              <div className="flex items-center justify-center w-2/6 rounded bg-[#FEEFF2] rounded-[8px] p-[4px] w-[48px] h-[48px] ">
                <img src={iconOptional} alt={iconOptional} />
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default NSCardButton;
